import { useExaminerManager } from "../../hooks/useExaminerManager";
import ChecklistExam from "./ChecklistExam";

export default function ExaminerManager({ examinerId, groups }) {
  const { onSubmit, selectedJury, setSelectedJury } =
    useExaminerManager(examinerId);

  return (
    <div className="min-h-full min-w-full bg-gray-100 p-4 flex items-center justify-start overflow-y-scroll">
      <div className="grid grid-cols-8 w-[25rem] grid-flow-row">
        {["Nom", "Jury 1", "Jury 2", "Jury 3", "Jury 4"].map((text, index) => (
          <span
            key={index}
            className={`rotate-[315deg] mb-2 font-semibold text-center whitespace-nowrap ${
              text === "Nom" ? "col-span-4" : "col-span-1"
            }`}
          >
            {text}
          </span>
        ))}
        {groups &&
          Object.keys(groups).map((groupKey) => (
            <ChecklistExam
              key={groups[groupKey].id}
              name={groupKey}
              groupId={groups[groupKey].id}
              selectedJury={selectedJury}
              setSelectedJury={setSelectedJury}
            />
          ))}
        <button
          type="submit"
          className="border border-black rounded
            px-2 py-1 mt-3 
            place-self-end col-start-8 
            bg-primary-validate hover:bg-secondary-validate 
            text-white font-bold"
          onClick={onSubmit}
        >
          Valider
        </button>
      </div>
    </div>
  );
}
